// src/api/leadsApi.js
import http from './http';
const API_URL = '/api/leads';

export const getLeads = () => http.get(API_URL);
export const createLead = (data) => http.post(API_URL, data);
export const deleteLead = (id) => http.delete(`${API_URL}/${id}`);
export const uploadAttachment = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return http.post(`${API_URL}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
